import { render, staticRenderFns } from "./PartnerPriceRequests.vue?vue&type=template&id=7bc5bcb7"
import script from "./PartnerPriceRequests.vue?vue&type=script&lang=js"
export * from "./PartnerPriceRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports